import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  Col,
  ControlLabel,
  FormGroup,
  FormControl,
  Glyphicon,
} from "react-bootstrap";
import { FieldArray, Field, ErrorMessage, getIn } from "formik";
import {
  ROLENAMES,
  LICENSE_KEY,
} from "provider/PermissionProvider/permissions";

import { getUnits } from "../../../Filter/action";

const Units = ({ disabled, getUnits }) => {
  const [units, setUnits] = useState([]);

  useEffect(() => {
    getUnits(ROLENAMES[LICENSE_KEY].id).then((resp) => {
      setUnits(resp);
    });
  }, []);

  const parseUnits = (selectedFamily) => {
    const families = units.map((unit) => unit.unit_family);
    const types = families
      .filter((family) => family.id === Number(selectedFamily))
      .flatMap((family) => family.unit_types);
    return {
      families,
      types,
    };
  };

  const renderRemoveButton = (index, onClick) => {
    if (index !== 0) {
      return (
        <Button
          bsStyle="link"
          bsSize="small"
          onClick={() => onClick(index)}
          style={{ paddingTop: "7px" }}
        >
          <Glyphicon glyph="remove" /> Remove
        </Button>
      );
    }
  };

  const renderOptions = (options) => {
    return (
      <Fragment>
        {options &&
          options.map((option) => {
            return (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            );
          })}
      </Fragment>
    );
  };

  const Family = ({ index, options, onRemoveClick, defaultValue }) => {
    const name = `units[${index}].family`;

    return (
      <Field name={name}>
        {({ field, form }) => {
          const touched = getIn(form.touched, name);
          const errors = getIn(form.errors, name);

          return (
            <FormGroup
              controlId={name}
              validationState={touched && errors ? "error" : null}
            >
              <Col componentClass={ControlLabel} sm={3}>
                Family
              </Col>
              <Col sm={6}>
                <FormControl
                  componentClass="select"
                  defaultValue={defaultValue}
                  onChange={field.onChange}
                >
                  {renderOptions(options)}
                </FormControl>
                <ErrorMessage
                  component="span"
                  className="text-danger"
                  name={name}
                />
              </Col>
              <Col sm={3}>{renderRemoveButton(index, onRemoveClick)}</Col>
            </FormGroup>
          );
        }}
      </Field>
    );
  };

  const Type = ({ index, options, defaultValue }) => {
    const name = `units[${index}].type`;

    return (
      <Field name={name}>
        {({ field, form }) => {
          const touched = getIn(form.touched, name);
          const errors = getIn(form.errors, name);

          return (
            <FormGroup
              controlId={name}
              validationState={touched && errors ? "error" : null}
            >
              <Col componentClass={ControlLabel} sm={3}>
                Type
              </Col>
              <Col sm={6}>
                <FormControl
                  componentClass="select"
                  defaultValue={defaultValue}
                  onChange={field.onChange}
                >
                  {renderOptions(options)}
                </FormControl>
                <ErrorMessage
                  component="span"
                  className="text-danger"
                  name={name}
                />
              </Col>
            </FormGroup>
          );
        }}
      </Field>
    );
  };

  const Version = ({ index, errors, touched }) => {
    const touchedStart = getIn(touched, `units[${index}].versionStart`);
    const errorStart = getIn(errors, `units[${index}].versionStart`);

    const touchedEnd = getIn(touched, `units[${index}].versionEnd`);
    const errorEnd = getIn(errors, `units[${index}].versionEnd`);

    return (
      <Fragment>
        <FormGroup
          validationState={
            (touchedStart && errorStart) || (touchedEnd && errorEnd)
              ? "error"
              : null
          }
        >
          <Col componentClass={ControlLabel} sm={3}>
            Version
          </Col>
          <Col sm={3}>
            <Field name={`units[${index}].versionStart`}>
              {({ field }) => (
                <Fragment>
                  <FormControl placeholder="Start" {...field} />
                  <ErrorMessage
                    component="span"
                    className="text-danger"
                    name={field.name}
                  />
                </Fragment>
              )}
            </Field>
          </Col>
          <Col sm={3}>
            <Field name={`units[${index}].versionEnd`}>
              {({ field }) => (
                <Fragment>
                  <FormControl placeholder="End" {...field} />
                  <ErrorMessage
                    component="span"
                    className="text-danger"
                    name={field.name}
                  />
                </Fragment>
              )}
            </Field>
          </Col>
        </FormGroup>
      </Fragment>
    );
  };

  const renderItems = (items, errors, touched, onRemoveClick) => {
    const { families } = parseUnits();

    return items.map((item, index) => (
      <Fragment key={index}>
        <Family
          index={index}
          options={families}
          onRemoveClick={onRemoveClick}
          defaultValue={item.family}
        />
        <Type
          index={index}
          options={parseUnits(item.family).types}
          defaultValue={item.type}
        />
        <Version index={index} errors={errors} touched={touched} />
      </Fragment>
    ));
  };

  return (
    <fieldset disabled={disabled}>
      <legend>
        <p className="text-uppercase">
          <strong>Units</strong>
        </p>
      </legend>
      <FieldArray name="units">
        {({ push, remove, form: { values, errors, touched } }) => (
          <Fragment>
            {renderItems(values["units"], errors, touched, remove)}
          </Fragment>
        )}
      </FieldArray>
    </fieldset>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  getUnits,
};

export default connect(mapStateToProps, mapDispatchToProps)(Units);
